// extracted by mini-css-extract-plugin
export default {"container":"DeleteContent_container__GXpWb","title":"DeleteContent_title__qao+g","footer":"DeleteContent_footer__fwN+8"};